(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hw-countdown]').forEach(function (el) {
    if (el.dataset.hwReady) return;
    el.dataset.hwReady = '1';
    var out = el.querySelector('[data-hw-countdown-out]');
    var cut = new Date(el.dataset.cutoff.replace(' ', 'T'));
    if (isNaN(cut.getTime())) { el.hidden = true; return; }
    function tick() {
      var s = Math.floor((cut - new Date()) / 1000);
      if (s <= 0) { out.textContent = 'has passed. Orders still ship within 24 hours.'; return; }
      var d = Math.floor(s / 86400); var h = Math.floor((s % 86400) / 3600);
      out.textContent = (d > 0 ? d + (d === 1 ? ' day ' : ' days ') : '') + h + (h === 1 ? ' hour' : ' hours');
    }
    tick(); setInterval(tick, 60000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-video"] && !Shopify.designMode) return;
  try {
    
  var hwReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hwVideos = [];
  document.querySelectorAll('[data-hw-video-wrap]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    var btn = wrap.querySelector('[data-hw-sound]');
    if (!v || v.dataset.hwReady) return;
    v.dataset.hwReady = '1';
    hwVideos.push(v);
    var wantSound = wrap.dataset.sound === 'true';
    v.loop = true; v.playsInline = true; v.setAttribute('playsinline', '');
    v.muted = !wantSound;
    function syncBtn() { if (btn) btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); }
    function tryPlay() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        if (!v.muted) { v.muted = true; syncBtn(); tryPlay(); } else { v.controls = true; }
      });
    }
    v._hwSync = syncBtn;
    syncBtn();
    if (btn) btn.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) { hwVideos.forEach(function (o) { if (o !== v && !o.muted) { o.muted = true; if (o._hwSync) o._hwSync(); } }); }
      syncBtn();
      if (v.paused) tryPlay();
    });
    if (hwReduce) { v.controls = true; return; }
    if (!('IntersectionObserver' in window)) { tryPlay(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) tryPlay(); else v.pause(); });
    }, { threshold: 0.25 }).observe(v);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
